module.exports = __webpack_public_path__ + "static/media/docMenu.e71cd774.svg";